import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import { MEDIUM_ITEM_SIZE, SystemTeam, SystemType } from "./_fields";
import { validatePlainText, validateEmail } from "./_utils";

type ConfigSoftwareTemplate = {
  eSystemCode: string;
  Title: string;
  eSystemType: string;
  eDescription: string;
  eTeam: string;
  eITTeamLead: string;
  eTeamLeadName: string;
  eITHead: string;
  eITHeadName: string;
  eITStaffMail: string;
  eITStaffName: string;
};

const currentDate = new Date();
const tomorrow = new Date();
tomorrow.setDate(currentDate.getDate() + 1);

export const configSoftwareTemplate: TemplatesValue<ConfigSoftwareTemplate> = {
  fileName: "DanhSachQuyTrinh",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    {
      header: "Mã quy trình",
      value: "AAA",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    {
      header: "Tên quy trình",
      value: "QT AAA",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    SystemType,
    {
      header: "Mô tả",
      value: "Quy trình cấp abc...",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    SystemTeam,
    {
      header: "Email bước 2",
      value: "abaca222@viags.vn",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validateEmail,
    },
    {
      header: "Họ tên bước 2",
      value: "Nguyễn Văn 2",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    {
      header: "Email bước 3",
      value: "abaca333@viags.vn",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validateEmail,
    },
    {
      header: "Họ tên bước 3",
      value: "Nguyễn Văn 3",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    {
      header: "Email bước 4",
      value: "abaca444@viags.vn",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validateEmail,
    },
    {
      header: "Họ tên bước 4",
      value: "Nguyễn Văn 4",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
  ],

  fields: [
    "eSystemCode",
    "Title",
    "eSystemType",
    "eDescription",
    "eTeam",
    "eITTeamLead",
    "eTeamLeadName",
    "eITHead",
    "eITHeadName",
    "eITStaffMail",
    "eITStaffName",
  ],
};
